import { Select, SelectProps } from '@shared/Form/Select'
import { useTranslation } from 'react-i18next'
import { ReserveResult, ReserveResultLabels } from '@services/app'

type Props = {
  showAll?: boolean
} & SelectProps

export default function AppReserveResultSelect({
  showAll = false,
  ...props
}: Props) {
  const { t } = useTranslation()

  const reserveResultOptions = Object.values(ReserveResult).map(value => ({
    label: ReserveResultLabels[value],
    value,
  }))

  return (
    <Select allowClear {...props}>
      {showAll && (
        <Select.Option key="all" value="">
          {t('common:all')}
        </Select.Option>
      )}
      {reserveResultOptions.map((item: any) => (
        <Select.Option key={item.value} value={item.value}>
          {item.label}
        </Select.Option>
      ))}
    </Select>
  )
}
